module.exports = __webpack_public_path__ + "static/media/beer.26f680f4.svg";